module.exports = __webpack_public_path__ + "img/logo-aula5.2a487094.png";